import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { useTranslation } from 'react-i18next'

// ui-kit
import { Row, Col } from '@navent-jobs/ui-kit/components/grid'
import Text from '@navent-jobs/ui-kit/components/text'

// hooks
import { useScreenSize } from '@navent-jobs/ui-kit/hooks/screen-size'
import features from '../../../../../constants/features-per-country'
import { SITE_ID } from '../../../../../constants'

// mixins
import {
  EmpresaDetail,
  NameCompany,
  DescripcionEmpresa,
  VideoWrapper,
  RatioResponsive,
  Video,
  Separador,
  ReviewPadder,
  CustomCol,
} from './mixins'

// componentes
import ResultadoCalificacionEmpresa from '../../../../resultado-calificacion-empresa'
import VerMasAvisosButton from './componets/VerMasAvisosButton'
import DetalleLookAndFeel from './componets/DetalleLookAndFeel'
import BannerGptw from '../../../../Gptw/banner'
import EmpresaVerificada from '../../../../empresa-verificada'

const GptwOrAverage = ({ gptwUrl, showGptw, reviewEnabled, aviso, mobileView = false }) => {
  if (showGptw && gptwUrl)
    return (
      <ReviewPadder>
        <BannerGptw url={gptwUrl} mobileView={mobileView} isFichaAviso />
      </ReviewPadder>
    )
  if (reviewEnabled)
    return (
      <ReviewPadder>
        <ResultadoCalificacionEmpresa
          isLoading={false}
          idCompany={aviso.empresa.id}
          denominacion={aviso.empresa.denominacion}
          mobileView={mobileView}
          isFichaAviso
          noMarginTop
          noTitle
        />
      </ReviewPadder>
    )

  return null
}

const Component = ({ aviso }) => {
  const { t } = useTranslation()

  const isZONAJOBS = aviso?.origenAviso === 'ZONAJOBS'
  const reviewEnabled = features[SITE_ID || 'BMAR'].reviews.enabled
  const gptwEnabled = features[SITE_ID || 'BMAR'].gptw.enabled
  const gptwShowLink = features[SITE_ID || 'BMAR'].gptw.companySummary.showLink
  const showGptw = gptwEnabled && aviso?.empresa.gptwUrl
  const gptwUrl = gptwShowLink ? aviso?.empresa.gptwUrl : t('companySummary.gptw.defaultUrl')

  const { isTabletLandscape, isDesktop } = useScreenSize()
  const isDesktopOrLandscape = isDesktop || isTabletLandscape

  /**
   * Validaciones para tab de La Empresa
   */
  const isConfidential = aviso?.empresa.confidencial
  const withCompanyId = aviso?.empresa.id !== undefined && aviso?.empresa.id !== null
  const withCompanyVideo = aviso?.empresa.videoUrl !== undefined && aviso?.empresa.videoUrl !== null
  const withCompanyDescription = aviso?.empresa.descripcion !== undefined && aviso?.empresa.descripcion !== null
  const showCompanyDetail =
    !isConfidential && withCompanyId && (withCompanyDescription || withCompanyVideo || reviewEnabled)
  const withCompanyInfo = aviso?.empresa.industria || aviso?.empresa.ciudad

  if (!showCompanyDetail || isZONAJOBS) {
    return null
  }

  return (
    <EmpresaDetail>
      {isDesktopOrLandscape ? (
        <Row>
          <CustomCol>
            {withCompanyInfo && <DetalleLookAndFeel empresa={aviso.empresa} showDescription />}
            <VerMasAvisosButton empresa={aviso.empresa} />

            {(showGptw || reviewEnabled) && (
              <NameCompany>
                <Text size="lg" fontWeight="semibold" variant="secondary">
                  {aviso.empresa.denominacion}
                  {aviso.empresa.validada && <EmpresaVerificada iconSize="16" marginLeft="4px" showMobile />}
                </Text>
              </NameCompany>
            )}
            <GptwOrAverage
              gptwUrl={gptwUrl}
              showGptw={showGptw}
              reviewEnabled={reviewEnabled}
              aviso={aviso}
              mobileView
            />

            {withCompanyVideo && (
              <VideoWrapper>
                <RatioResponsive>
                  <Video width="100%" src={aviso.empresa.videoUrl} frameBorder="0" allowFullScreen title="video" />
                </RatioResponsive>
              </VideoWrapper>
            )}
          </CustomCol>
        </Row>
      ) : (
        <>
          <Row>
            <Col>
              <NameCompany>
                <Text size="lg" variant="secondary" fontWeight="semibold">
                  {aviso.empresa.denominacion}
                  {aviso.empresa.validada && <EmpresaVerificada iconSize="16" marginLeft="4px" showMobile />}
                </Text>
              </NameCompany>
            </Col>
          </Row>
          <Row>
            <Col lg={{ size: 8, order: 1 }}>
              <GptwOrAverage gptwUrl={gptwUrl} showGptw={showGptw} reviewEnabled={reviewEnabled} aviso={aviso} />
              {withCompanyInfo && <DetalleLookAndFeel empresa={aviso.empresa} />}
              <VerMasAvisosButton empresa={aviso.empresa} />
              {withCompanyDescription && (
                <DescripcionEmpresa>{ReactHtmlParser(aviso.empresa.descripcion)}</DescripcionEmpresa>
              )}
              {withCompanyVideo && (
                <VideoWrapper>
                  <RatioResponsive>
                    <Video width="100%" src={aviso.empresa.videoUrl} frameBorder="0" allowFullScreen title="video" />
                  </RatioResponsive>
                </VideoWrapper>
              )}
            </Col>
          </Row>
          <Separador />
        </>
      )}
    </EmpresaDetail>
  )
}

export default Component
